import OrdersAPIService from '@/modules/orders/services/apiService'
import OrderItemService from '@/modules/orders/services/orderItemService'

import ReportView  from '@/modules/reporting/views/report.vue'

export default class OrdersModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.ordersService = new OrdersAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
    Vue.prototype.$apiService.orderItemService = new OrderItemService(Vue.prototype.$api)
  }

  getRoutes() {
    return [
      {
        path: '/orders',
        name: 'OrderList',
        component: () => import('@/modules/orders/views/orderList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Orders',
          menuLink: '/orders',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/orders/new',
        name: 'OrderNew',
        component: () => import('@/modules/orders/views/orderNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'New Order',
          menuLink: '/orders',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Orders', link: '/orders'}
          ],
        }
      },
      {
        path: '/orders/configuration',
        name: 'OrderConfiguration',
        component: () => import('@/modules/orders/views/orderConfiguration.vue'),
        meta: {
          requiresAuth: true,
          title: 'Order Configuration',
          menuLink: '/orders/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/orders/:id',
        name: 'Order',
        component: () => import('@/modules/orders/views/order.vue'),
        meta: {
          requiresAuth: true,
          title: 'Order',
          menuLink: '/orders',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Orders', link: '/orders'}
          ]
        }
      },
      {
        path: '/orders/:id/externalsetup',
        name: 'OrderExternalSetup',
        component: () => import('@/modules/orders/views/orderExternalSupplierSetup.vue'),
        meta: {
          requiresAuth: true,
          title: 'Order - External Supplier Setup',
          menuLink: '/orders',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Orders', link: '/orders'}
          ]
        }
      },
      {
        path: '/orders/:id/report',
        name: 'OrderReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Order Report',
          layout: 'Blank',
          report: {
            url: '/reporting/orders/:id/report',
            variables: ['id'],
            options: ['production']
          },
        }
      },
      {
        path: '/orders/:id/panellabels',
        name: 'OrderProductionPanelLabels',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Order - Production Panel Labels',
          layout: 'Blank',
          report: {
            url: '/orders/:id/panellabels',
            variables: ['id'],
            options: ['reprint']
          },
        }
      },
      {
        path: '/orders/:id/panellabels/:panelId',
        name: 'OrderProductionPanelSingleLabel',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Order - Production Panel Labels',
          layout: 'Blank',
          report: {
            url: '/orders/:id/panellabels/:panelId',
            variables: ['id', 'panelId'],
            options: ['reprint']
          },
        }
      }
    ]
  }
}
